import { Errors } from '../errors';
import { assert } from '@awayjs/graphics';
import { runtimeWriter } from './writers';
import { interpret } from '../int';
import { release } from '@awayfl/swf-loader';
/**
 * All code lives within an application domain.
 */
var AXApplicationDomain = /** @class */ (function () {
    function AXApplicationDomain(sec, parent) {
        this.sec = sec;
        this.parent = parent;
        this.system = parent ? parent.system : this;
        this._abcs = [];
        this._binarySymbols = {};
    }
    AXApplicationDomain.prototype.addBinarySymbol = function (symbol) {
        this._binarySymbols[symbol.className] = symbol;
    };
    AXApplicationDomain.prototype.getBinarySymbol = function (className) {
        return this._binarySymbols[className];
    };
    AXApplicationDomain.prototype.loadABC = function (abc) {
        assert(this._abcs.indexOf(abc) < 0);
        this._abcs.push(abc);
    };
    AXApplicationDomain.prototype.loadAndExecuteABC = function (abc) {
        this.loadABC(abc);
        this.executeABC(abc);
    };
    AXApplicationDomain.prototype.executeABC = function (abc) {
        var lastScript = abc.scripts[abc.scripts.length - 1];
        this.executeScript(lastScript);
    };
    AXApplicationDomain.prototype.findClassInfo = function (name) {
        for (var i = 0; i < this._abcs.length; i++) {
            var abc = this._abcs[i];
            for (var j = 0; j < abc.instances.length; j++) {
                var c = abc.classes[j];
                if (c.instanceInfo.getName().name === name) {
                    return c;
                }
            }
        }
        return null;
    };
    AXApplicationDomain.prototype.executeScript = function (scriptInfo) {
        assert(scriptInfo.state === 0 /* None */);
        runtimeWriter && runtimeWriter.writeLn('Running Script: ' + scriptInfo);
        var global = this.sec.createAXGlobal(this, scriptInfo);
        scriptInfo.global = global;
        scriptInfo.state = 1 /* Executing */;
        interpret(scriptInfo.getInitializer(), global.scope, null).apply(global, []);
        scriptInfo.state = 2 /* Executed */;
    };
    AXApplicationDomain.prototype.findProperty = function (mn, _strict, execute) {
        var script = this.findDefiningScript(mn, execute);
        if (script) {
            return script.global;
        }
        return null;
    };
    AXApplicationDomain.prototype.getClass = function (mn) {
        var classObject = this.getProperty(mn, true, true);
        if (classObject && !classObject.axApplicationDomain) {
            classObject.axApplicationDomain = this;
        }
        return classObject;
    };
    AXApplicationDomain.prototype.getProperty = function (mn, strict, execute) {
        var global = this.findProperty(mn, strict, execute);
        if (global) {
            return global.axGetProperty(mn);
        }
        if (mn.name != 'void') {
            this.sec.throwError('ReferenceError', Errors.DefinitionNotFoundError, mn.name);
        }
    };
    AXApplicationDomain.prototype.findDefiningScript = function (mn, execute) {
        if (mn.script)
            return mn.script;
        // Look in parent domain first.
        var script;
        if (this.parent) {
            script = this.parent.findDefiningScript(mn, execute);
            if (script) {
                return script;
            }
        }
        // Search through the loaded abcs.
        for (var i = 0; i < this._abcs.length; i++) {
            var abc_1 = this._abcs[i];
            script = this._findDefiningScriptInABC(abc_1, mn, execute);
            if (script) {
                if (!mn.mutable)
                    mn.script = script;
                return script;
            }
        }
        // Still no luck, so let's ask the security domain to load additional ABCs and try again.
        var abc = this.system.sec.findDefiningABC(mn);
        if (abc) {
            this.loadABC(abc);
            script = this._findDefiningScriptInABC(abc, mn, execute);
            release || assert(script, 'Shall find class in loaded ABC');
            if (!mn.mutable)
                mn.script = script;
            return script;
        }
        return null;
    };
    AXApplicationDomain.prototype._findDefiningScriptInABC = function (abc, mn, execute) {
        var scripts = abc.scripts;
        for (var j = 0; j < scripts.length; j++) {
            var script = scripts[j];
            var traits = script.traits;
            traits.resolve();
            if (traits.getTrait(mn)) {
                // Ensure script is executed.
                if (execute && script.state === 0 /* None */) {
                    this.executeScript(script);
                }
                return script;
            }
        }
        return null;
    };
    return AXApplicationDomain;
}());
export { AXApplicationDomain };
